var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#017EFF;}\r\n\t.st1{fill:#8AB7E9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.7,480.2c1.9-11,11.4-18.8,22.5-18.8c46.7,0.2,92.3-11.4,132.9-26.9l13-5.2c8.8-3.6,17.4-7.3,25.6-11.2 C562.2,175.5,300.4,73.6,296.2,72c0.7,0.7,1.4,1.4,2.1,2.2c52.5,55.2,78.3,132.2,70.4,207.9c-8.5,81.3-61.1,135.8-102.1,202.3 c-14.3,23.3-26.7,46.9-36.7,70.7c-19-29.7-38.5-76.5-51.1-150.1c0,0-63.4,135.2-55.3,282.4c0,0,0.1,184.8,152,284.4 c4.7,3.1,10.5,6.3,17.1,9.5c80.9,39.5,204.2,34.8,282-8.4C353,800.1,376.6,551,388.7,480.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949.4,507.8c-1.6-9.6-10-16.4-19.7-16.4C828.6,491.7,731.9,430,699.4,407c-6.9-4.9-16.2-4.9-23.1,0 c-32.6,23-129.3,84.7-230.4,84.4c-9.7-0.1-18,6.8-19.7,16.4c-12.1,70.3-37.4,341.3,252.5,487.8c5.6,2.8,12.3,2.8,17.9,0 C986.7,849.1,961.5,578.1,949.4,507.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmColor);
export default __webpack_public_path__ + "static/media/RM_color.44b6f6d6a5844d1ab844f8cd77a1aa10.svg";
export { ForwardRef as ReactComponent };